class collectionPage {
  init() {
    $('a[href="#toggle-sizes"]').click(function(e){
      e.preventDefault();
      $('.collection-sizes--opts').toggle();
    });

    $('.collection-sizes--opts a').click(function(e){
      e.preventDefault();
      $('.collection-sizes--opts a').not(this).removeClass('act');
      $(this).toggleClass('act');
      if($(this).hasClass('act')){
        var seekSize = 'size_'+$(this).attr('href').substr(1);
        $('.product-item').each(function(){
          var sizes = $(this).attr('data-sizes');
          if (sizes.indexOf(seekSize)>-1) {
            $(this).parent().show();
          } else {
            $(this).parent().hide();
          }
        })
        // $('.product-item:not([data-sizes*="'+sz+'"])').fadeOut(200);
        // $('.product-item:[data-sizes*="'+sz+'"]').fadeIn(200);
      } else {
        $('.products-list--item').show();
      }
    });

    $('.collection-sidebar--menu a').each(function(){
      $(this).attr('data-href', $(this).attr('href'));
    });

    $('.collection-sidebar--views a').click(function(e){
      // e.preventDefault();
      $(this).siblings().removeClass('cur');
      $(this).addClass('cur');
      var id = $(this).attr('data-id');
      $('.collection-list').removeClass('grid index').addClass(id);

      if(id=='index') {
        $('.collection-sidebar--menu a').each(function(){
          $(this).attr('href', $(this).attr('href')+'#index');
        })
      } else {
        $('.collection-sidebar--menu a').each(function(){
          $(this).attr('href', $(this).attr('data-href'));
        })
      }
    });

    if(window.location.hash == '#index') {
      $('.collection-sidebar--views a[href*="#index"]').click()
    }

    const $collectionList = $('.collection-list');
    const $productItems = $collectionList.find('.product-item');
    const hoverEntries = [];
    const hoverStateKey = 'collectionHoverState';
    const remFactor = 0.013541666666666667;

    $productItems.each(function(){
      const $item = $(this);
      const entry = {
        $img: $item.find('a.product-item--image'),
        frame: null,
        lastPointer: null,
        imgHeight: null
      };

      $item.data(hoverStateKey, entry);
      hoverEntries.push(entry);
    });

    const scheduleHoverUpdate = (entry) => {
      if(!entry.$img.length) {
        return;
      }

      if(entry.frame){
        return;
      }

      entry.frame = window.requestAnimationFrame(() => {
        entry.frame = null;

        if(!entry.lastPointer){
          return;
        }

        const rem = window.innerWidth * remFactor;

        if(entry.imgHeight === null){
          entry.imgHeight = entry.$img.outerHeight();
          if(!entry.imgHeight){
            entry.imgHeight = window.innerHeight * 0.7;
          }
        }

        const viewportHeight = window.innerHeight;
        const maxTop = viewportHeight - entry.imgHeight - rem;
        const left = entry.lastPointer.clientX;
        let top = entry.lastPointer.clientY;

        if(top > maxTop){
          top = maxTop;
        }

        entry.$img.css({
          left,
          top
        });
      });
    };

    $(window).off('resize.collectionHover').on('resize.collectionHover', () => {
      hoverEntries.forEach((entry) => {
        entry.imgHeight = null;
      });
    });

    $productItems.off('mousemove.collectionHover mouseleave.collectionHover click.collectionHover')
      .on('mousemove.collectionHover', function(e){
        if(window.touch || !$collectionList.hasClass('index')){
          return;
        }

        const entry = $(this).data(hoverStateKey);
        if(!entry){
          return;
        }

        entry.lastPointer = {
          clientX: e.clientX,
          clientY: e.clientY
        };

        scheduleHoverUpdate(entry);
      })
      .on('mouseleave.collectionHover', function(){
        const entry = $(this).data(hoverStateKey);
        if(entry){
          entry.lastPointer = null;
        }
      })
      .on('click.collectionHover', function(e){
        if($collectionList.hasClass('index')){
          e.preventDefault();
          const href = $(this).find('.product-item--image').attr('href');
          if(href){
            window.location.href = href;
          }
        }
      });

    $('.product-item[data-sizes]').each(function(){
      var sz = $(this).attr('data-sizes').trim();
      var szString = '';
      if(sz.indexOf('Default')<0 && sz.toLowerCase().indexOf('one')<0){
        var szs = sz.split(' ');
        for(var i=0;i<szs.length;i++){
          // if(szs[i].indexOf('size_')>=0){
          szs[i] = szs[i].trim();
          var s = szs[i].replace('size_','');
          let isnum = /^\d+$/.test(s);
          if(!isnum) {
            szString += s;

            if(i < szs.length-1) {
              szString += ', ';
            }
          } else {
            // console.log(i, szs.length);
            if(i==0 || i==szs.length-1){
              szString += s;
              if(i==0) szString += '–';
            }
          }
          // }
        }
      } else {
        szString += 'OS';
      }
      $(this).find('.product-item--info--sizes p').text(szString);
    });

    // findMaterialFromDescriptions();
    $('.collection-list').css('opacity', 1);

    if($('.has-intro').length>0) {
      $(window).scroll(function(){
        if(window.innerWidth >= 768) {
          if($('.collection-sidebar.stick').length==0) {
            var sidebarRect = $('.collection-sidebar').get(0).getBoundingClientRect();
            if(sidebarRect.bottom < (window.innerHeight - window.innerWidth*0.013541666666666667)) {
              $('.collection-sidebar').addClass('stick');
            }
          } else {
            if($('.collection-sidebar').position().top <= $('.collection-list').position().top) {
              $('.collection-sidebar.stick').removeClass('stick');
            }
          }
        }
      });
    }
  } // end INIT
}

export default collectionPage;
